<template>
  <nav
    :class="{ 'l-default__sidebar__show': showMenu }"
    v-click-outside="CLICK_OUTSIDE"
  >
    <div class="l-default__sidebar__close-button">
      <i @click="show(false)" class="icofont-close c-close-icon"></i>
    </div>
    <router-link :to="{ name: 'home' }">
      <Logo :width="50" />
    </router-link>
    <div class="u-display-flex-lg-up u-align-items-center">
      <ul
        class="l-default__sidebar__list"
        v-for="(item, i) in menuJson"
        :key="i"
      >
        <component
          :is="item.path ? 'router-link' : 'span'"
          class="l-default__sidebar__list__link"
          exact-active-class="l-default__sidebar__list__link--active"
          :to="item.path"
        >
          <li
            class="l-default__sidebar__list__item"
            @click="SET_ACTIVES(i, item.path)"
          >
            <span>
              <chip class="u-text-align-center">
                <i :class="` icofont-${item.icon}`"></i
              ></chip>
              <span> {{ $t(item.name) }} </span>
            </span>
            <i
              v-if="
                !item.path &&
                item.sub.filter(
                  (sub) => sub.validRoleSub && sub.validAuthorizeSub
                ).length > 0
              "
              :class="`icofont-rounded-${
                actives.some((active) => active === i) ? 'up' : 'down'
              }`"
            ></i>
          </li>
        </component>
        <ul
          v-if="actives.some((active) => active === i)"
          class="l-default__sidebar__list u-padding-xxsmall l-default__sidebar__list__accordion"
        >
          <component
            :is="sub.path ? 'router-link' : 'span'"
            exact-active-class="l-default__sidebar__list__link--active"
            class="l-default__sidebar__list__link"
            v-for="(sub, j) in item.sub.filter(
              (sub) => sub.validRoleSub && sub.validAuthorizeSub
            )"
            :key="i + '-' + j"
            :to="sub.path"
          >
            <li class="l-default__sidebar__list__item">
              <span>
                <i :class="`u-margin-right-xsmall icofont-${sub.icon}`"></i>
                <span> {{ $t(sub.name) }} </span>
              </span>
            </li>
          </component>
        </ul>
      </ul>
      <ul class="l-default__sidebar__list u-display-none-lg-up">
        <span
          @click="showUpdateAdmin = true"
          class="l-default__sidebar__list__link"
        >
          <li class="l-default__sidebar__list__item">
            <div>
              <chip> <i class="icofont-user"></i></chip>
              <span> {{ $t("common.myProfile") }} </span>
            </div>
          </li>
        </span>
      </ul>
      <ul class="l-default__sidebar__list u-display-none-lg-up">
        <span @click="SIGN_OUT()" class="l-default__sidebar__list__link">
          <li class="l-default__sidebar__list__item">
            <div>
              <chip> <i class="icofont-logout"></i></chip>
              <span> {{ $t("common.signout") }} </span>
            </div>
          </li>
        </span>
      </ul>
    </div>
    <div style="padding: 5px">
      <dropdown align="right" class="u-display-none-md-down">
        <template #title>
          <div class="u-display-flex u-align-items-center">
            <avatar></avatar>
            <i class="u-margin-left-xsmall icofont-rounded-down"></i>
          </div>
        </template>
        <template #content>
          <div class="u-padding-xsmall">
            <div class="u-display-flex u-align-items-center">
              <avatar size="sm"></avatar>
              <div class="u-margin-left-xsmall">
                <div>
                  <small class="u-font-size-xsmall">
                    {{ getActiveUser.userInfo.fullname }}
                  </small>
                </div>
                <div>
                  <small class="u-color-muted u-font-size-xsmall">
                    {{ $t(`admins.${getActiveUser.userInfo.role}`) }}
                  </small>
                </div>
              </div>
            </div>
            <ul class="c-list u-margin-top-xsmall">
              <li class="c-list__item" @click="showUpdateAdmin = true">
                <div>
                  <i class="icofont-user"></i> {{ $t("common.myProfile") }}
                </div>
              </li>
              <li class="c-list__item">
                <div @click="showLanguageModal = true">
                  <img
                    class="s-change-language__item__image"
                    :src="`https://flagicons.lipis.dev/flags/4x3/${
                      $i18n.locale === 'en' ? 'gb' : $i18n.locale || 'tr'
                    }.svg`"
                    width="20"
                    :alt="$i18n.locale"
                  />
                  {{ $t("common.changeLanguage") }}
                </div>
              </li>
              <li @click="SIGN_OUT()" class="c-list__item">
                <div>
                  <i class="icofont-logout"></i> {{ $t("common.signout") }}
                </div>
              </li>
            </ul>
          </div>
        </template>
      </dropdown>
      <LanguageModal v-model="showLanguageModal" />
    </div>
    <Modal
      :title="$t('admins.update')"
      persistent
      hide-footer
      v-model="showUpdateAdmin"
    >
      <FormAdmins
        v-if="getActiveUser.token"
        @refresh="SIGN_OUT()"
        edit
        :item="getActiveUser.userInfo"
      />
    </Modal>
  </nav>
</template>

<script>
import menuJson from "./menu.json";
import Logo from "./Logo.vue";
import { mapGetters } from "vuex";
import Chip from "@/components/Base/Chip.vue";
import Modal from "@/components/Base/Modal.vue";
import Avatar from "@base/Avatar.vue";
import Dropdown from "@base/Dropdown.vue";
import FormAdmins from "@/components/Admins/FormAdmins.vue";
import LanguageModal from "@/components/Shared/LanguageModal.vue";
export default {
  components: {
    Logo,
    Chip,
    Modal,
    Avatar,
    Dropdown,
    FormAdmins,
    LanguageModal,
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.show(false);
        if (window.innerWidth > 768) this.actives = [];
      },
    },
  },
  data() {
    return {
      showUpdateAdmin: false,
      actives: [],
      menuJson: menuJson,
      showMenu: false,
      showLanguageModal: false,
    };
  },
  computed: {
    ...mapGetters(["getActiveUser", "getAuthorizeList"]),
  },
  methods: {
    CLICK_OUTSIDE() {
      this.actives = [];
    },
    SIGN_OUT() {
      this.$store.dispatch("SIGNOUT_USER", {
        message: this.$t("authMessages.sessionIsClosed"),
        variant: "success",
      });
    },
    SET_ACTIVES(index, path) {
      if (path) return;
      const activeIndex = this.actives.findIndex((active) => active === index);
      if (activeIndex > -1) this.actives.splice(activeIndex, 1);
      else {
        this.actives = [];
        this.actives.push(index);
      }
    },
    show(show = true) {
      this.showMenu = show;
    },
    filterMenu() {
      // Admin için özel kontrol - sadece Admin rolüne ait menüleri göster
      if (this.getActiveUser.userInfo.role === "Admin") {
        return this.menuJson
          .filter((item) => item.roles.includes("Admin"))
          .map((item) => ({
            ...item,
            validRole: true,
            validAuthorize: true,
            sub: item.sub.map((sub) => ({
              ...sub,
              validRoleSub: true,
              validAuthorizeSub: true,
            })),
          }));
      }

      // Diğer roller için menu kontrolü
      const menu = this.menuJson.map((item) => {
        // Ana menü için role kontrolü
        const validRole = item.roles.includes(this.getActiveUser.userInfo.role);

        // Ana menü için authorize kontrolü
        const validAuthorize =
          item.authorize.length === 0 || // Eğer authorize array boşsa true
          !this.getAuthorizeList.some((userAuth) =>
            item.authorize.some(
              (menuAuth) =>
                menuAuth.method === userAuth.authorityInfo.method &&
                menuAuth.controller === userAuth.authorityInfo.controller &&
                menuAuth.action === userAuth.authorityInfo.action
            )
          );

        // Alt menüler için kontroller
        const subItems = item.sub.map((sub) => {
          const validRoleSub = sub.roles.includes(
            this.getActiveUser.userInfo.role
          );
          const validAuthorizeSub =
            sub.authorize.length === 0 || // Eğer authorize array boşsa true
            !this.getAuthorizeList.some((userAuth) =>
              sub.authorize.some(
                (menuAuth) =>
                  menuAuth.method === userAuth.authorityInfo.method &&
                  menuAuth.controller === userAuth.authorityInfo.controller &&
                  menuAuth.action === userAuth.authorityInfo.action
              )
            );

          console.log(
            sub.name,
            validRoleSub,
            validAuthorizeSub,
            "sub.name",
            sub,
            this.getAuthorizeList
          );
          return {
            ...sub,
            validRoleSub,
            validAuthorizeSub,
          };
        });

        return {
          ...item,
          validRole,
          validAuthorize,
          sub: subItems,
        };
      });

      // Filtreleme:
      // 1. Alt menüsü olmayan itemlar için: Direkt role ve authorize kontrolü
      // 2. Alt menüsü olan itemlar için:
      //    - Ana menünün role ve authorize kontrolü VE
      //    - En az bir alt menünün geçerli olması kontrolü
      return menu.filter((item) => {
        // Alt menüsü olmayan itemlar için kontrol
        if (item.sub.length === 0) {
          return item.validRole && item.validAuthorize;
        }

        // Alt menüsü olan itemlar için kontrol
        const hasValidSubItems = item.sub.some(
          (sub) => sub.validRoleSub && sub.validAuthorizeSub
        );

        return item.validRole && item.validAuthorize && hasValidSubItems;
      });
    },
  },
  mounted() {
    this.menuJson = this.filterMenu();
    console.log(this.menuJson);
  },
};
</script>

<style></style>
